// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"634":"196dfd36","817":"54dd2145"}[chunkId] + ".chunk.js";
};